import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/land-monitoring/$propertyId/')({
  validateSearch: (search: Record<string, unknown>): { justActivated?: boolean } => ({
    justActivated: search.justActivated === true ? true : undefined,
  }),
});
